import React, { Component } from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';

/* eslint camelcase: 0 */
class Tree extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: true,
    };
  }

  toggleExpand = () => {
    this.setState(state => ({
      expanded: !state.expanded,
    }));
  };

  handleClick = () => {
    this.props.updateActiveGroup(this.props.data.id);
    this.props.updateMyOrganization(false);
  };

  render() {
    const { name, children, member_count, id } = this.props.data;
    const hasChildren = children.length > 0;
    const iconStyle = classNames({
      'NestedList-icon': true,
      'ml-4': true,
      'NestedList-icon--rotated': this.state.expanded,
    });
    const listStyle = classNames({
      'Tree-node--hidden': !this.state.expanded,
    });
    const nodeListStyle = classNames({
      'Tree-nodeList': true,
      'Tree-root': id === this.props.root,
    });
    let childNodes = [];

    if (hasChildren) {
      childNodes = children.map(child => (
        <li key={child.id}>
          <Tree
            data={child}
            updateMyOrganization={this.props.updateMyOrganization}
            updateActiveGroup={this.props.updateActiveGroup}
            root={this.props.root}
          />
        </li>
      ));
    }

    return (
      <div className={nodeListStyle}>
        {hasChildren && (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events
          <span className={iconStyle} onClick={this.toggleExpand}>
            <Icon
              name="triangle_down"
              className="Icon--small c-brand-gray c-p"
            />
          </span>
        )}
        {!hasChildren && <div className="Tree-filler" />}
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-is-valid */}
        <a onClick={this.handleClick}>
          {name} ({member_count})
        </a>
        {hasChildren && <ul className={listStyle}>{childNodes}</ul>}
      </div>
    );
  }
}

export default Tree;
